<script>
export default {
  name: "testPaperDialog",
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      userList: [],
      paperList: [],
    };
  },
  watch: {
    visible(val) {
      this.show = val;
      if (val) {
        this.getDetail();
      }
    },
  },
  mounted() {
    this.show = this.visible;
  },
  methods: {
    getDetail() {
      console.log("获取试卷信息");
      this.loading = true;
      this.$cloud
        .get("examination/test/detail", { id: this.id })
        .then((res) => {
          console.log("试卷信息", res);
          this.userList = res.userList;
          this.paperList = res.paperList;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
      console.log("关闭");
      this.$emit("update:visible", false);
    },
    closed() {
      this.paperList = [];
      this.userList = [];
    },
  },
};
</script>

<template>
  <div>
    <el-dialog
      :title="title + '-查看'"
      :visible.sync="show"
      width="400px"
      @closed="closed"
      :before-close="handleClose"
    >
      <div class="p-6" v-loading="loading">
        <p>试卷列表</p>
        <el-table :data="paperList" style="width: 100%">
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="name" label="试卷名"> </el-table-column>
          <el-table-column prop="score" label="分数"> </el-table-column>
        </el-table>
        <p>用户列表</p>
        <el-table :data="userList" max-height="400px" style="width: 100%">
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="username" label="姓名"> </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped></style>
